// BubbleChart.js
import {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import { Bubble } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";

ChartJS.register(...registerables);
const BubbleChart = forwardRef((props, ref) => {
  const bubbleChartRef = useRef(null);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [packAData, setPackAData] = useState([]);
  const [packACount, setPackACount] = useState([]);
  const [packBData, setPackBData] = useState([]);
  const [packBCount, setPackBCount] = useState([]);
  const [packCData, setPackCData] = useState([]);
  const [packCCount, setPackCCount] = useState([]);
  const [packDData, setPackDData] = useState([]);
  const [packDCount, setPackDCount] = useState([]);
  const [packTotalCount, setPackTotalCount] = useState([]);
  const [maxCount, setMaxCount] = useState(0);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/bubble_chart",
        body: { filterdata: gloablfilter, packType: "A_SOH_Value" },
      },
      appyDataA
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/bubble_chart",
        body: { filterdata: gloablfilter, packType: "B_SOH_Value" },
      },
      appyDataB
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/bubble_chart",
        body: { filterdata: gloablfilter, packType: "C_SOH_Value" },
      },
      appyDataC
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/bubble_chart",
        body: { filterdata: gloablfilter, packType: "D_SOH_Value" },
      },
      appyDataD
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/bubble_chart_totalcount",
        body: { filterdata: gloablfilter, packType: "D_SOH_Value" },
      },
      appyDataTotalCount
    );
  }, [gloablfilter, props.selectTemp]);

  const appyDataA = (data) => {
    setPackAData(data.formattedData);
    setPackACount(data.totalR);
  };
  const appyDataB = (data) => {
    setPackBData(data.formattedData);
    setPackBCount(data.totalR);
  };
  const appyDataC = (data) => {
    setPackCData(data.formattedData);
    setPackCCount(data.totalR);
  };
  const appyDataD = (data) => {
    setPackDData(data.formattedData);
    setPackDCount(data.totalR);
  };
  const appyDataTotalCount = (data) => {
    setPackTotalCount(data.value);
  };

  useEffect(() => {
    const max = Math.max(packACount, packBCount, packCCount, packDCount);
    setMaxCount(max);
  }, [packACount, packBCount, packCCount, packDCount]);

  const data = {
    datasets: [
      {
        label: "Pack A",
        data: packAData,
        // data: [
        //   { x: 1, y: 99, r: 3 },
        //   { x: 1, y: 98, r: 22 },
        //   { x: 1, y: 97.5, r: 8 },
        //   { x: 1, y: 98.5, r: 33 },
        //   { x: 1, y: 96, r: 1 },
        //   { x: 1, y: 97, r: 1 },
        //   { x: 1, y: 95, r: 0 },
        //   { x: 1, y: 95.5, r: 0 },
        // ],
        // backgroundColor: "#8EA8BF",
        backgroundColor: "rgba(142, 168, 191, 0.60)",
        borderColor: "#808080",
      },
      {
        label: "Pack B",
        data: packBData,
        // data: [
        //   { x: 2, y: 99, r: 3 },
        //   { x: 2, y: 98, r: 20 },
        //   { x: 2, y: 97.5, r: 7 },
        //   { x: 2, y: 98.5, r: 33 },
        //   { x: 2, y: 96, r: 1 },
        //   { x: 2, y: 97, r: 1 },
        //   { x: 2, y: 95, r: 0 },
        //   { x: 2, y: 95.5, r: 0 },
        // ],
        // backgroundColor: "#F9F974",
        backgroundColor: "rgba(249, 249, 116, 0.60)",
        borderColor: "#808080",
      },
      {
        label: "Pack C",
        data: packCData,
        // data: [
        //   { x: 3, y: 99, r: 3 },
        //   { x: 3, y: 98, r: 20 },
        //   { x: 3, y: 97.5, r: 7 },
        //   { x: 3, y: 98.5, r: 33 },
        //   { x: 3, y: 96, r: 1 },
        //   { x: 3, y: 97, r: 1 },
        //   { x: 3, y: 95, r: 0 },
        //   { x: 3, y: 95.5, r: 0 },
        // ],
        // backgroundColor: "#EE9D65",
        backgroundColor: "rgba(238, 157, 101, 0.60)",
        borderColor: "#808080",
      },
      {
        label: "Pack D",
        data: packDData,
        // data: [
        //   { x: 4, y: 99, r: 3 },
        //   { x: 4, y: 98, r: 20 },
        //   { x: 4, y: 97.5, r: 7 },
        //   { x: 4, y: 98.5, r: 33 },
        //   { x: 4, y: 96, r: 1 },
        //   { x: 4, y: 97, r: 1 },
        //   { x: 4, y: 95, r: 0 },
        //   { x: 4, y: 95.5, r: 0 },
        // ],
        // backgroundColor: "#AFAFAF",
        backgroundColor: "rgba(175, 175, 175, 0.60)",
        borderColor: "#808080",
      },
    ],
  };

  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: "bottom",
  //       font: {
  //         size: 14,
  //       },
  //     },
  //     title: {
  //       display: true,
  //       // text: "Bubble Chart Example",
  //     },
  //   },
  //   scales: {
  //     x: {
  //       type: "linear",
  //       beginAtZero: true,
  //       max: 5,
  //       ticks: {
  //         stepSize: 1,
  //         precision: 0,
  //       },
  //     },
  //     y: {
  //       beginAtZero: false,
  //       min: 95,
  //       max: 101,
  //       title: {
  //         display: true,
  //         text: "SOH",
  //         font: {
  //           size: 14,
  //           weight: "bold",
  //         },
  //         color: "#000",
  //       },
  //     },
  //   },
  // };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: {
            size: 12, // Increase font size
            weight: "bold", // Bold font
          },
        },
      },
      title: {
        display: true,
        font: {
          size: 18, // Increase font size
          weight: "bold", // Bold font
        },
      },
      datalabels: {
        color: "#000",
        font: {
          size: 16, // Increase font size
          weight: "bold", // Bold font
        },
        formatter: (value, context) => {
          return value.r; // Show the radius as the label
        },
      },
    },
    scales: {
      x: {
        type: "linear",
        beginAtZero: true,
        max: 5,
        ticks: {
          stepSize: 1,
          precision: 0,
          font: {
            size: 14, // Increase font size
            weight: "bold", // Bold font
          },
        },
      },
      y: {
        beginAtZero: false,
        min: 95,
        max: 101,
        title: {
          display: true,
          text: "SOH",
          font: {
            size: 16,
            weight: "bold",
          },
          color: "#000",
        },
        ticks: {
          font: {
            size: 14, // Increase font size
            weight: "bold", // Bold font
          },
        },
      },
    },
  };

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      bubbleChartRef,
      packTotalCount,
      maxCount,
    }),
  }));
  return (
    <>
      <div
        className="row ml-4 mb-4"
        style={{ height: "500px", width: "1000px" }}
        id="bubble-chart-div"
        ref={bubbleChartRef}
      >
        <Bubble
          id="bubble-chart"
          data={data}
          options={options}
          style={{ backgroundColor: "#D9D9D9" }}
        />
        <div className="col text-start" id={"sohgraphnote"}>
          <span
            className="text-start"
            style={{ color: "red", fontSize: "12px", fontWeight: "bolder" }}
          >
            Note :{" "}
          </span>
          <span className="text-end" style={{ fontSize: "12px" }}>
            The size of the bubble represents the count of the vehicles under
            particular SOH.
          </span>
        </div>
      </div>
      <div id={"bubble-text1"}>
        Out of {packTotalCount} buses, {maxCount}
      </div>
      <div id={"bubble-text2"}>are showing the degredation in SOH.</div>
    </>
  );
});
export default BubbleChart;
